import { render } from "./ProgramsView.vue?vue&type=template&id=756d1426"
import script from "./ProgramsView.vue?vue&type=script&lang=js"
export * from "./ProgramsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__